import classnames from "classnames";
import React, { ReactNode } from "react";

import styles from "./LoginState.module.scss";
import { DefaultTFuncReturn } from "i18next";

const LoginState = ({
  children,
  error,
  className,
}: {
  children?: ReactNode | DefaultTFuncReturn;
  error?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={classnames(
        styles.root,
        "tw-text-center tw-rounded",
        { "bg-danger text-white tw-p-6": error },
        className,
      )}
    >
      {children}
    </div>
  );
};

export default LoginState;
